import React, { useState } from 'react';
import {
  Box,
  Container,
  HStack,
  Text,
  Link,
  Button,
  useDisclosure,
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';
import { APP_VERSION } from '../../utils/versionCheck.ts';
import ChangelogModal from './ChangelogModal.tsx';

const Footer: React.FC = () => {
  const { t } = useTranslation();
  const { isOpen, onOpen, onClose } = useDisclosure();
  
  return (
    <Box 
      bg="var(--gris-bleute)" 
      borderTop="1px solid"
      borderColor="rgba(139, 148, 179, 0.2)"
      py={3}
      px={4}
      mt="auto"
    >
      <Container maxW="container.xl">
        <HStack 
          justify="center" 
          spacing={4} 
          wrap="wrap"
          fontSize="xs"
        >
          <Text color="var(--texte-secondaire)" fontWeight="medium">
            © 2025-2026 QuizVS
          </Text>
          
          <Text color="rgba(139, 148, 179, 0.5)">•</Text>
          
          <Link 
            as={RouterLink}
            to="/terms"
            color="var(--bleu-electrique)"
            _hover={{ 
              textDecoration: 'underline',
              color: "var(--magenta-vif)"
            }}
            fontSize="xs"
          >
            {t('footer.terms')}
          </Link>
          
          <Link 
            as={RouterLink}
            to="/privacy"
            color="var(--bleu-electrique)"
            _hover={{ 
              textDecoration: 'underline',
              color: "var(--magenta-vif)"
            }}
            fontSize="xs"
          >
            {t('footer.privacy')}
          </Link>

          <Text color="var(--texte-secondaire)" fontSize="xs">
            Site développé avec le ❤️ par{' '}
            <Link
              href="https://neiko.fr/"
              isExternal
              color="var(--bleu-electrique)"
              _hover={{
                textDecoration: 'underline',
                color: 'var(--magenta-vif)',
              }}
            >
              NeikoStream
            </Link>
          </Text>

          <Text color="rgba(139, 148, 179, 0.5)">•</Text>

          <Text
            as="button"
            onClick={onOpen}
            color="var(--texte-secondaire)"
            fontSize="xs"
            cursor="pointer"
            _hover={{ color: 'var(--bleu-electrique)' }}
            transition="color 0.2s"
          >
            v{APP_VERSION}
          </Text>
        </HStack>
      </Container>

      <ChangelogModal isOpen={isOpen} onClose={onClose} />
    </Box>
  );
};

export default Footer;
